import { Action } from '@ngrx/store';
import { ServerConfig } from '../../models/ServerConfig';

export enum ApplicationActionTypes {
  InitApplicationConfig = 'InitApplicationConfig'
}

export class InitApplicationConfig implements Action {
  readonly type = ApplicationActionTypes.InitApplicationConfig;

  constructor(public payload: ServerConfig) {
  }
}

export type ApplicationActions =
  InitApplicationConfig;
